import { CommonDataContext } from "context/CommonDataContext";
import { extractResource } from "helper/extractResource";
import { useContext } from "react";
import NoInternetIcon from "../../public/svg/NoInternet";

export const InternetNotFoundPage = () => {
	const { resources } = useContext(CommonDataContext);
	
	return (
		<div className="flex items-center justify-center h-screen">
			<div className="flex flex-col items-center">
				 <NoInternetIcon />
				<p className="text-lg font-semibold m-1">{extractResource(resources, "userOfflineHeadingText")}</p>
				<p className="text-base m-1">{extractResource(resources, "userOfflineContentText")}</p>              
			</div>
		</div>
	);
};
